export enum SignInProvider {
  GOOGLE = 'google.com',
}

export interface User {
  id: string;
  name: string | null;
  signInProvider: SignInProvider;
  email: string | null;
  emailVerified: boolean | null;
  externalAuthSystemId: string | null;
  tenantId: string;
  createdAt: string;
}
